export const ADD_STATUS_INFO = "ADD_STATUS_INFO";
export const ADD_STATUS_LIST = "ADD_STATUS_LIST";
export const RESET_STATUS = "RESET_STATUS";

export const addStatusInfo = (data) => {
  return {
    type: ADD_STATUS_INFO,
    data,
  };
};
export const addStatusList = (data) => {
  return {
    type: ADD_STATUS_LIST,
    data,
  };
};


export const resetStatus = (data) => {
  return {
    type: RESET_STATUS,
    data,
  };
};
